import { FC, ReactNode } from 'react';

export type DangerZoneProps = {
  title: string;
  description?: ReactNode;
  /** The destructive control the caller places at the end of the row. */
  action: ReactNode;
  /** Placement only: the frame, spacing and stacking are the zone's. */
  className?: string;
};

/**
 * The one danger zone.
 *
 * It mirrors the payment/discount rule: one bordered surface set apart from
 * the save action, with the caller passing the destructive Button. Below
 * 620px the action stacks under the text.
 */
const DangerZone: FC<DangerZoneProps> = ({ title, description, action, className }) => (
  <div className={['ui-danger-zone', className].filter(Boolean).join(' ')}>
    <div className="ui-danger-zone-text">
      <span className="ui-danger-zone-title">{title}</span>
      {description && <span className="ui-danger-zone-hint">{description}</span>}
    </div>
    {action}
  </div>
);

export default DangerZone;
